/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_Report_Muscles_HowInputs */

const en_us2_progress_report_muscles_how = /** @type {(inputs: Progress_Report_Muscles_HowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Each set counts 1 for its target muscle and ½ for the helpers. The target is today's active plan.`)
};

const pt_br2_progress_report_muscles_how = /** @type {(inputs: Progress_Report_Muscles_HowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada série conta 1 para o músculo-alvo e ½ para os auxiliares. A meta é a do plano ativo hoje.`)
};

const es_419_progress_report_muscles_how = /** @type {(inputs: Progress_Report_Muscles_HowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada serie cuenta 1 para su músculo principal y ½ para los auxiliares. La meta es la del plan activo hoy.`)
};

const pt_pt2_progress_report_muscles_how = /** @type {(inputs: Progress_Report_Muscles_HowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada série conta 1 para o músculo-alvo e ½ para os auxiliares. A meta é a do plano ativo hoje.`)
};

const fr_fr2_progress_report_muscles_how = /** @type {(inputs: Progress_Report_Muscles_HowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chaque série compte 1 pour le muscle cible et ½ pour les muscles auxiliaires. L'objectif est celui du programme actif aujourd'hui.`)
};

const de_de2_progress_report_muscles_how = /** @type {(inputs: Progress_Report_Muscles_HowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeder Satz zählt 1 für den Zielmuskel und ½ für die Hilfsmuskeln. Das Ziel stammt aus dem heute aktiven Plan.`)
};

const it_it2_progress_report_muscles_how = /** @type {(inputs: Progress_Report_Muscles_HowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ogni serie conta 1 per il muscolo principale e ½ per quelli ausiliari. L'obiettivo è quello della scheda attiva oggi.`)
};

/**
* | output |
* | --- |
* | "Each set counts 1 for its target muscle and ½ for the helpers. The target is today's active plan." |
*
* @param {Progress_Report_Muscles_HowInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_report_muscles_how = /** @type {((inputs?: Progress_Report_Muscles_HowInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Report_Muscles_HowInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_report_muscles_how(inputs)
	if (locale === "es-419") return es_419_progress_report_muscles_how(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_report_muscles_how(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_report_muscles_how(inputs)
	if (locale === "de-DE") return de_de2_progress_report_muscles_how(inputs)
	if (locale === "it-IT") return it_it2_progress_report_muscles_how(inputs)
	return en_us2_progress_report_muscles_how(inputs)
});
export { progress_report_muscles_how as "progress-report.muscles_how" }